import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { getBreedingEventList, doBreedingEventDelete } from "../../../../redux/breedingevent/breedingEventState";
import { handleTableChange } from "../../../../utils/index";

const BreedingEventTable = ({ recordList, pagination, doSearch, doDelete, filters }) => {
  	const columns = [
		{
	        title: `Mating Date`,
	        dataIndex: 'mating_date',
	        key: 'mating_date',
	        width: '10%',
	        render:(mating_date) => <span>{mating_date}</span>
	    },
		{
	        title: `Sire ID`,
	        dataIndex: 'sire',
	        key: 'sire',
	        width: '10%',
	        render:(sire) => <span>{sire?.tag_id}</span>
	    },
		{
	        title: `Dam ID`,
	        dataIndex: 'dam',
	        key: 'dam',
	        width: '10%',
	        render:(dam) => <span>{dam?.tag_id}</span>
	    },	
		{
	        title: `Offsprings`,
	        dataIndex: 'offsprings',
	        key: 'offsprings',
	        width: '10%',
	        render:(offsprings) => <span>{offsprings}</span>
	    },
		{
	        title: `Farm Location`,
	        dataIndex: 'farm',
	        key: 'farm',
	        width: '18%',
	        sorter: true,
	        render:(farm) => <span>{farm?.name}</span>
	    },
		{
	        title: `Remarks`,
	        dataIndex: 'remarks',
	        key: 'remarks',
	        width: '20%',
	        sorter: true,
	        render:(remarks) => <span>{remarks}</span>
	    },
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/breeding-events/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'id',
	        key: 'id',
	        width: '10%',
	        render:(id) => <CrudOption baseRoute="/console/breeding-events" recordId={id} deleteHandler={doDelete}/>
	    },
    ];
	
	useEffect(() => {
		console.log('test');
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden mb-3">	      	
	      		<Table
		        	dataSource={recordList}
		        	columns={columns} 
		            rowKey={(record) => record.id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}
		            onChange={handleTableChange(doSearch, filters)}  
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.breedingEvent.recordList?.items,
	pagination: state.breedingEvent.recordList?.pagination,
	filters: state.breedingEvent.recordList?.filters,
  	requesting: state.breedingEvent.recordList?.requesting,
  	error: state.breedingEvent.recordList?.error,	  
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getBreedingEventList(filters)),
  doDelete: (id) => dispatch(doBreedingEventDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BreedingEventTable);